/** Export everything that you wanted eagerly loaded upon application load.
 *  This can include all components needed for the application to initialize
 *  and any components that are shared throughout the application.
 */

const isLocalEnvironment = process.env.ENV_NAME === 'local'

// In local dev, MSW's service worker needs to finish registering and reach
// 'activated' before any component fetches, or those fetches bypass the
// mocks and hit real (unmocked) endpoints. Await that before registering
// any custom element that fetches on connect.
const mswReady = isLocalEnvironment
  ? import('./mocks/browser').then(({ worker }) => worker.start({ onUnhandledRequest: 'bypass' }))
  : Promise.resolve()

mswReady
  .catch((err) => {
    console.warn('[MSW] Service worker failed to register, mocks will be handled by Playwright:', err)
  })
  .then(async () => {
    // Register custom elements with di-fs-* names
    await import('./gui/components/fs-components')
    await import('./gui/components/custom-components')

    // Register the dealer-free Carfax OAuth callback custom element so the shell
    // can render <di-carfax-callback> at the registered redirect URL.
    await import('./gui/components/di-carfax-callback')

    // Registers shared/shell custom elements, including <di-landing-view>, which
    // fetches feature flags as soon as it connects — must not run before MSW is ready.
    await import('@di-shared')
    await import('@di-components')
  })
